module.exports = __webpack_public_path__ + "staticmobile/img/video_swiper_bg.0a6f360.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/video_swiper_bg.jpg
// module id = QtHz
// module chunks = 0